import React from 'react';
import { BackButtonProps } from "../Interfaces/Interface";
const BackButton: React.FC<BackButtonProps> = ({ className = 'back-button2', label = 'Back' }) => {
  const handleBackClick = () => {window.history.back();};
  return (
    <button className={className} onClick={handleBackClick}>{label}</button>
  );
};
export default BackButton;